// //                                                                  summanusb@gmail.com
// import { useState,useEffect } from 'react';
// import { useAppContext } from '../context/AppContext';
// import '../css/Login.css';
// import { useNavigate } from 'react-router-dom';
// import {Label} from '../css/Shared'
// import { toast } from 'react-toastify';
// export default function Login() {
//   const { login, error,authState } = useAppContext();
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const navigate = useNavigate();

//     useEffect(() => {
//     if (authState.isAuth) {
//       navigate('/dashboard'); // already logged in, go straight to dashboard
//     }
//   }, [authState.isAuth, navigate]);


// const handleSubmit = async (e) => {
//   e.preventDefault();

//     const success = await login(username, password);
// console.log(success)
// if (success.stat === false) {
//   toast.error(success.message || 'Unknown Login failed');
// } else {
//   navigate('/dashboard');
// }    
// };

// <form onSubmit={handleSubmit}>
//   <button type="submit">Login</button>
// </form>


//   return (
//     <div className="auth-container">
//       <div className="auth-card">

//         {/* Logo */}
//         <div style={{textAlign:'center',padding:'0px 0px 60px 0px'}}>
    
//           <Label color="white" letterSpacing="5px" fontSize="clamp(1.6rem, 1.6rem, 1.8rem)">Lightning Presort<span style={{fontSize:'.7rem'}}>®</span></Label>
//         </div>

//         {/* Welcome Section */}
//         <div className="auth-welcome" style={{padding:"10px 0px"}}>
//           <Label color="white" >Welcome Back!</Label>
       
//         </div>

//         {/* Error message */}
//         {error && <div className="auth-error">{error}</div>}

//         {/* Login Form */}
//         <form className="auth-form" onSubmit={handleSubmit}>
//           <input
//             type="text"
//             placeholder="Username"
//             value={username}
//             onChange={(e) => setUsername(e.target.value)}
//             required
//           />
//           <input
//             type="password"
//             placeholder="Password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             required
// autocomplete="off"
//           />
//           <button className="auth-button" type="submit">Login</button>
//         </form>

//         {/* Links */}
//         <div className="auth-links">
//           <a href="/forgot-password">Forgot Password?</a>
//           <a href="/register">Register</a>
//         </div>

//       </div>
//     </div>
//   );
// }



//                                                                  summanusb@gmail.com
import { useState, useEffect } from 'react';
import { useAppContext } from '../context/AppContext';
import '../css/Login.css';
import { useNavigate } from 'react-router-dom';
import { Label } from '../css/Shared';
import { toast } from 'react-toastify';

export default function Login() {
  const { login, error, authState } = useAppContext();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);

  const navigate = useNavigate();

  // If already logged in go to dashboard
  useEffect(() => {
    if (authState.isAuth) {
      navigate('/dashboard');
    }
  }, [authState.isAuth, navigate]);

  // Load remembered credentials
  useEffect(() => {
    const savedUser = localStorage.getItem('rememberUser');
    const savedPass = localStorage.getItem('rememberPass');

    if (savedUser && savedPass) {
      setUsername(savedUser);
      setPassword(savedPass);
      setRememberMe(true);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (rememberMe) {
      localStorage.setItem('rememberUser', username);
      localStorage.setItem('rememberPass', password);
    } else {
      localStorage.removeItem('rememberUser');
      localStorage.removeItem('rememberPass');
    }

    const success = await login(username, password);
    console.log(success);

    if (success.stat === false) {
      toast.error(success.message || 'Unknown Login failed');
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">

        {/* Logo */}
        <div style={{ textAlign: 'center', padding: '0px 0px 60px 0px' }}>
          <Label
            color="white"
            letterSpacing="5px"
            fontSize="clamp(1.6rem, 1.6rem, 1.8rem)"
          >
            Lightning Presort<span style={{ fontSize: '.7rem' }}>®</span>
          </Label>
        </div>

        {/* Welcome */}
        <div className="auth-welcome" style={{ padding: "10px 0px" }}>
          <Label color="white">Welcome Back!</Label>
        </div>

        {/* Error */}
        {error && <div className="auth-error">{error}</div>}

        {/* Login Form */}
        <form className="auth-form" onSubmit={handleSubmit}>

          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="off"
          />

          {/* Remember Me */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginTop: '6px',
              marginBottom: '10px'
            }}
          >
            <input
            autoComplete='off'
              type="checkbox"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
              style={{ marginRight: '6px' }}
            />
            <label style={{ color: 'white', fontSize: '.8rem' }}>
              Remember Me
            </label>
          </div>

          <button className="auth-button" type="submit">
            Login
          </button>

        </form>

        {/* Links */}
        <div className="auth-links">
          <a href="/forgot-password">Forgot Password?</a>
          <a href="/register">Register</a>
        </div>

      </div>
    </div>
  );
}